import { render, staticRenderFns } from "./EntryShow_Mobile.vue?vue&type=template&id=24db4c86&"
import script from "./EntryShow_Mobile.vue?vue&type=script&lang=js&"
export * from "./EntryShow_Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports